import React from "react";
import {connect} from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Button from "components/CustomButtons/Button.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import ArrowDropDown from "@material-ui/icons/ArrowDropDown";
import Checkbox from "@material-ui/core/Checkbox";
import Check from "@material-ui/icons/Check";
import Table from "components/Table/Table.jsx";
import AddCircle from "@material-ui/icons/AddCircle";
import Close from "@material-ui/icons/Close";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import Input from "@material-ui/core/Input";
import SymbolsModal from './SymbolsModal'

import styles from "assets/jss/material-dashboard-pro-react/views/form";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

import {mrPerType} from 'enums'
import _ from 'lodash'
import {profileSave, profileFetch} from 'actions/profiles'
import {
  profileSpecialCaseSave,
  profileSpecialCasesFetchHelper,
	profileSpecialCaseFetch,
	profileSpecialCaseRemove
} from 'actions/profileSpecialCases'
import {
  currenciesFetch,
  currencyFilter
} from 'actions/currencies'
import {
  fetchAllSymbols
} from 'actions/symbols'
import {
  symbolGroupsFetch,
  symbolGroupFilter
} from 'actions/symbolGroups'
import {
  danger,
  success,
} from 'actions/notification'

const customStyle = {
  selectFormControlBorder: {
    "& > div": {
      "&:before": {
        borderBottomWidth: "1px !important",
        borderBottomColor: "silver !important"
      },
    }
  },
  selectCustom: {
    fontSize: '14px',
  },
  paddingZero: {
    padding: '0 !important'
  }
}

class Commodities extends React.Component {
  button = React.createRef()
	state = {
    symbolType: 'COMMODITY',
		form: {
      id: 0,
      spread: '',
      markup: '',
      //percentage: '',
      commission: '',
      commissionCurrencyId: '',
      commissionType: ''
    },
    profileSpecialCases: [],
    symbolTree: [],
    typeSymbols: [],
    selectedSpecialCase: {},
    openModal: false,
    showTable: false,
    goToNext: true
  }
  componentDidUpdate(prevProps, prevState){
    if (prevProps.additionalWizardData !== this.props.additionalWizardData) {
      this.setData()
    }
    if (prevProps.changeStep !== this.props.changeStep) {
      // handle submit action
      if(this.props.stepDataObject.stepId === this.props.changeStep.currentStep.stepId){
        this.button.current.click()
        this.props.navigationStepChange(this.props.changeStep.nextStep.key)
        this.setState({...this.state, goToNext: false})
      }
    }
  }
  setData(){
    const {allSymbols, profile, specialCases} = this.props.additionalWizardData
    const {symbolType} = this.state
    let typeSymbols = allSymbols.filter((x) => x.type === symbolType)

    let groups= [...new Set(typeSymbols.filter((s) => s.groupId).map((s) => s.groupId))] // symbol groups with whatever is inside
    let symbolGroups = []

    groups.forEach((group)=> {
      let baseSymbols = typeSymbols.filter((s) => s.groupId === group && !s.parentSymbolId)
      let symbolsWithParent = typeSymbols.filter((s) => s.parentSymbolId)
      baseSymbols.forEach((base) => {
        let children = symbolsWithParent.filter((s) => s.parentSymbolId === base.symbolId)
        base.children = children
      })
      //console.log('Group', group, 'base symbols ', baseSymbols)
      symbolGroups.push({groupedBy: group, baseSymbols: baseSymbols})
    })
      
    //base symbols with children without groups
    let symbolsWithoutGroup= typeSymbols.filter((s) => !s.parentSymbolId && !s.groupId)

    symbolsWithoutGroup.forEach((parent) => {
      let children = typeSymbols.filter((s) => s.parentSymbolId === parent.symbolId && !s.groupId && !parent.groupId)
      if(children){
        parent.children = children
      }
    })
    
    if(profile){
      const forexType = specialCases.find((x) => x.symbolTypes.includes(symbolType))
      let filterSpecialCases = specialCases.filter((x) => x.symbols && x.symbols.find((s) => s.type === symbolType))
      let typeSpecialCases = this.filterDeletedSpecialCases(filterSpecialCases)
      let showTable = typeSpecialCases.length !== 0
      if(specialCases.lenght === 0 || !forexType){
        this.setState({
          ...this.state,
          form:{
            id: 0,
            spread: profile.spread,
            markup: profile.markup,
            //percentage: profile.percentage,
            commission: profile.commission,
            commissionCurrencyId: profile.commissionCurrencyId,
            commissionType: profile.commissionType,
          },
          profileSpecialCases: typeSpecialCases,
          symbolTree: [...symbolGroups, ...symbolsWithoutGroup],
          typeSymbols,
          showTable
        })
      } else{
        this.setState({
          ...this.state,
          form:{
            id: forexType.profileSpecialCaseId,
            spread: forexType.spread,
            markup: forexType.markup,
            //percentage: forexType.percentage,
            commission: forexType.commission,
            commissionCurrencyId: forexType.commissionCurrencyId,
            commissionType: forexType.commissionType,
            },
          profileSpecialCases: typeSpecialCases,
          symbolTree: [...symbolGroups, ...symbolsWithoutGroup],
          typeSymbols,
          showTable
        })
      }
    } else {
      this.setState({
        ...this.state,
        symbolTree: [...symbolGroups, ...symbolsWithoutGroup],
        typeSymbols
      })
    }
  }
	change(event,name){
    this.setState({
      ...this.state,
      form:{
        ...this.state.form,
        [name]:event.target.value
      },
    })
	}
	getInput(data){
    return   <CustomInput
        labelText={
          <span>
            {data.name} {(data.required?<small>*</small>: '')}
          </span>
        }
        id={data.key}
        formControlProps={{
          fullWidth: true
        }}
        inputProps={{
          onChange: event => this.change(event, data.key),
          required:data.required,
          value:this.state.form[data.key] || '',
          type:data.type,
          endAdornment: (
            <InputAdornment
              position="end"
              className={this.props.classes.inputAdornment}
            >
              {data.icon}
            </InputAdornment>
          )
        }}
    />
	}
	submit(e){
    e.preventDefault()
    const {symbolType} = this.state
    const match = this.props.match
    let data = this.state.form
    data.profileSpecialCaseId = data.id
    data.symbolTypes = [symbolType]
    if(data.commissionType === ''){
      delete data.commissionType
    }
    if(data.commissionCurrencyId === ''){
      delete data.commissionCurrencyId
    }
    this.props.saveSpecialCase(match.params.id, data)
      .then(e => {
        if(this.state.goToNext) this.props.goToNextStep()
      })
      .catch(e=>{this.props.danger(e+'',4);})
		
  }
  addNewSpecialCase(){
    if(this.state.newSpecialCase) return
    this.setState({
      newSpecialCase:{
        spread: '',
        markup: '',
        //percentage: '',
        commission: '',
        commissionCurrencyId: '',
        commissionType: '',
        symbols: [],
        symbolGroups: [],
        symbolTypes: []
      }
    })
  }
  renderTableInput(e, property, placeholder, width){
    return(
      <Input
        value={e[property]}
        placeholder={placeholder}
        style={{maxWidth: width || '130px'}}
        onChange={(s) => this.changeSpecialCase(s, e.profileSpecialCaseId, property)}
      />
    )
  }
  renderTableSelect(e, property, placeholder, options){
    const {classes} = this.props
    return(
      <Select
        required={false}
        native
        value={e[property] || '' }
        style={{width: '100px'}}
        MenuProps={{ className: classes.selectMenu }}
        classes={{ select: classes.select + ' ' + classes.selectCustom }}            
        inputProps={{
          onChange: event => this.changeSpecialCase(event, e.profileSpecialCaseId, property),
          //id: property
        }}
      >
        <option value="" disabled>{placeholder}</option>
        {Object.values(options).map((item, ind) => 
          <option key={ind} value={item.value}>{item.label}</option>
        )}
      </Select>
    )
  }
  renderTableSymbols(e){
    let hasValues = e.symbolGroups.length !== 0 || e.symbols.length !== 0 ? true : false
    e.symbols = e.symbols.length !== 0
      ? _(e.symbols).filter((s) => s.type === this.state.symbolType).orderBy(['name'], ['asc']).value()
      : e.symbols
    let symbolSet = (e.symbols.length !== 0 && e.symbols[0].name)  || (e.symbolGroups.length !== 0 && e.symbols[0].name)
      ? `${e.symbols[0].name.substr(0, 6)}...,` : ''
    return (
      <div
        style={{
          borderBottom: '1px solid gray',
          minHeight: '5px',
          width: '110px',
          display:'flex',
          cursor: 'pointer',
          padding: '6px 0 1px'
        }}
        onClick={() => this.setState({openModal: true, selectedSpecialCase: e})}
      >
        <div style={{width: '100%'}}>{hasValues? symbolSet : 'Select...'}</div>
        <ArrowDropDown style={{float: 'right', color: 'gray'}} />
      </div>
    )
  }
  changeNewProfileSpecialCase(e, property){
    let {newSpecialCase} = this.state
    newSpecialCase[property] = e.target.value
    this.setState({...this.state, newSpecialCase})
  }
  changeSpecialCase(e, id, property){
    if(!id) return this.changeNewProfileSpecialCase(e, property)
    let {profileSpecialCases} = this.state
    profileSpecialCases.find((x) => x.profileSpecialCaseId === id)[property] = e.target.value
    this.setState({
      ...this.state,
      profileSpecialCases: profileSpecialCases
    })
  }
  setSymbols(profileSpecialCaseId, data){
    const {profileSpecialCases, typeSymbols} = this.state
    if(profileSpecialCaseId){
      profileSpecialCases.forEach((item) => {
        if(item.profileSpecialCaseId === profileSpecialCaseId){
          item.symbolGroups = data.symbolGroups
          item.symbols = []
          data.symbols.forEach((symb) => {
            item.symbols.push(typeSymbols.find((z) => z.symbolId === symb))
          })
        }
      })
      this.setState({...this.state, profileSpecialCases})
    } else{
      let {newSpecialCase} = this.state
      newSpecialCase.symbolGroups = data.symbolGroups
      newSpecialCase.symbols = []
      data.symbols.forEach((symb) => {
        newSpecialCase.symbols.push(typeSymbols.find((z) => z.symbolId === symb))
      })
      this.setState({...this.state, newSpecialCase})
    }
    
  }
  saveTableItem(i){
    const match = this.props.match
    let data = i
    let isNew = !data.profileSpecialCaseId
    if(data.commissionType === ''){
      delete data.commissionType
    }
    if(data.commissionCurrencyId === ''){
      delete data.commissionCurrencyId
    }
    //if special case has symbols from other symbol types
    let otherTypeSymbol = data.symbols.find((x) => x.type !== this.state.symbolType)
    if(otherTypeSymbol) {
      //remove the symbols of this tab symbol type specialcase
      let oldSpecialCase = {...data}
      oldSpecialCase.symbols = i.symbols.filter((x)=> x.type !== this.state.symbolType)
      oldSpecialCase.symbols = oldSpecialCase.symbols.map((s) => s.symbolId)
      this.props.saveSpecialCase(match.params.id, oldSpecialCase)
      .then(() => {
        // create new special case with the symbols of this tab symbol type
        let newCase = {...data}
        newCase.symbols = i.symbols.filter((x)=> x.type === this.state.symbolType)
        newCase.symbols = newCase.symbols.map((s) => s.symbolId)
        delete newCase.profileSpecialCaseId
        this.props.saveSpecialCase(match.params.id, newCase).then(() => {
          this.props.success('Custom Setting updated ',4)
          this.fetchData()
        }).catch(e=>{this.props.danger(e+'',4);})
      })
      .catch(e=>{this.props.danger(e+'',4);})
    } else {
      data.symbols = data.symbols.map((s) => s.symbolId)
      this.props.saveSpecialCase(match.params.id, data)
      .then(e => {
        //update symbol tree state
        this.props.success(isNew? 'Custom Setting added':'Custom Setting updated ',4)
        this.fetchData()
        if(isNew){
          this.setState({...this.state, newSpecialCase: null})
        }
      })
      .catch(e=>{this.props.danger(e+'',4);})
    }
  }
  fetchData(){
    //update special cases object in wizard
    this.props.fetchSpecialCases(this.props.match.params.id).then((data) => {
      let filterSpecialCases = data.filter((x) => x.symbols && x.symbols.find((s) => s.type === this.state.symbolType))
      let typeSpecialCases = this.filterDeletedSpecialCases(filterSpecialCases)
      this.setState({...this.state, profileSpecialCases: typeSpecialCases})
    })
  }
  deleteTableItem(i){
    let isNew = !i.profileSpecialCaseId
    if(isNew){
      this.setState({...this.state, newSpecialCase: null})
      return
    }
    const match = this.props.match
    //if this special case has symbols from other types remove only the spacialCase symbols of this tab
    let otherTypeSymbol = i.symbols.find((x) => x.type !== this.state.symbolType)
    if(otherTypeSymbol){
      let newData = {...i}
      newData.symbols = i.symbols.filter(x => x.type !== this.state.symbolType)
      newData.symbols = newData.symbols.map((x) => x.symbolId)
      this.props.saveSpecialCase(match.params.id, newData).then(() => {
        this.props.success('Custom Setting removed ',4)
        this.fetchData()
      }).catch(e=>{this.props.danger(e+'',4);})
    } else{
      this.props.removeSpecialCase(match.params.id, i.profileSpecialCaseId)
      .then(e => {
        this.props.success('Custom Setting removed ',4)
        this.fetchData()
      })
      .catch(e=>{this.props.danger(e+'',4);})
    }
  }
  filterDeletedSpecialCases(data){
    const {symbolType} = this.state
    const {allSymbols} = this.props.additionalWizardData
    //remove if symbols inside special case don't exists in symbols
    let newData = []  
    data.forEach((specialCase) => {
      let typeSymbols = specialCase.symbols.filter((c) => c.type === symbolType)
      
      let validSymbols = false
      typeSymbols.forEach((s)=>{
        if(validSymbols) return
        if(allSymbols.find((a) => a.symbolId === s.symbolId)){
          validSymbols = true
        }
      })
      
      if(validSymbols) {
        newData.push({...specialCase})
      }
    })
    return newData
  }
  findSymbolsColumnName(e){
    e.symbols = e.symbols.length !== 0
      ? _(e.symbols).filter((s) => s.type === this.state.symbolType).orderBy(['name'], ['asc']).value()
      : e.symbols
    let columnTxt = (e.symbols.length !== 0 && e.symbols[0].name) || (e.symbolGroups.length !== 0 && e.symbols[0].name)
      ? `${e.symbols[0].name.substr(0, 6)}` : ''
    return columnTxt
  }
  render() {
    const {classes, currencies} = this.props
    let {profileSpecialCases} = this.state
    profileSpecialCases = _(profileSpecialCases).orderBy((d)=> this.findSymbolsColumnName(d), 'asc').value()
    let specialCases = []
    if(this.state.newSpecialCase){
      specialCases = [this.state.newSpecialCase, ...profileSpecialCases]
    } else{
      specialCases = profileSpecialCases
    }

  	return (
			<form onSubmit={(e) => this.submit(e)}>
				<GridContainer justify="center">
					
          <GridContainer justify="center">
            <GridItem xs={5} sm={5} md={3}>
              <div style={{display: 'flex', flexDirection: 'column'}}>
                <div style={{borderBottom: '1px solid #eee'}}>
                  <span>Spread Rebate</span>
                </div>
                {this.getInput({
                    key:'spread',
                    name:'Pips',
                    icon:'',
                    type:'text',
                    required:false
                })}  
              </div>
            </GridItem>
            
            <GridItem xs={5} sm={5} md={3}>
              <div style={{display: 'flex', flexDirection: 'column'}}>
                <div style={{borderBottom: '1px solid #eee'}}>
                  <span>Markup Rebate</span>
                </div>
                {this.getInput({
                    key:'markup',
                    name:'Pips',
                    icon:'',
                    type:'text',
                    required:false
                })}
              </div>
            </GridItem>

            {/* <GridItem xs={3} sm={3} md={2}>
              <div style={{display: 'flex', flexDirection: 'column'}}>
                <div style={{borderBottom: '1px solid #eee'}}>
                  <span>Rebate on Shares</span>
                </div>
                {this.getInput({
                    key:'percentage',
                    name:'%',
                    icon:'',
                    type:'text',
                    required:false
                })}  
              </div>
            </GridItem> */}

            <GridItem xs={11} sm={11} md={5}>
              <div style={{display: 'flex', flexDirection: 'column'}}>
                <div style={{borderBottom: '1px solid #eee'}}>
                  <span>Commission Rebate</span>
                </div>
                <GridContainer justify="center">
                  <GridItem xs={4}>
                    {this.getInput({
                        key:'commission',
                        name:'Input',
                        icon:'',
                        type:'text',
                        required:false
                    })}
                  </GridItem>
                    
                  <GridItem xs={4}>

                    <FormControl
                      fullWidth
                      className={classes.selectFormControl + ' ' + classes.selectFormControlBorder}
                      style={{marginTop:'10px', marginBottom: '17px'}}
                    >

                      <InputLabel
                        htmlFor="commissionCurrencyId"
                        className={classes.selectLabel}
                      >
                        Currency
                      </InputLabel>

                      <Select
                        required={false}
                        native
                        value={this.state.form.commissionCurrencyId || '' }
                        MenuProps={{ className: classes.selectMenu }}
                        classes={{ select: classes.select + ' ' + classes.selectCustom }}            
                        inputProps={{
                          onChange: event => this.change(event, "commissionCurrencyId"),
                          id: "commissionCurrencyId"
                        }}
                      >
                        <option value="" disabled></option>
                        {Object.values(currencies).map(item => 
                          <option key={item.currencyId} value={item.currencyId}>{item.name}</option>
                        )}
                      </Select>  
                    </FormControl>

                  </GridItem>

                  <GridItem xs={4}>
                    
                    <FormControl
                      fullWidth
                      className={classes.selectFormControl + ' ' + classes.selectFormControlBorder}
                      style={{marginTop:'10px', marginBottom: '17px'}}
                    >

                      <InputLabel
                        htmlFor="commissionType"
                        className={classes.selectLabel}
                      >
                        Per lot/million
                      </InputLabel>

                      <Select
                        required={false}
                        native
                        value={this.state.form.commissionType || '' }
                        MenuProps={{ className: classes.selectMenu }}
                        classes={{ select: classes.select + ' ' + classes.selectCustom }}            
                        inputProps={{
                          onChange: event => this.change(event, "commissionType"),
                          id: "commissionType"
                        }}
                      >
                        <option value="" disabled></option>
                        {Object.values(mrPerType).map((item, i) => 
                          <option key={i} value={item.key}>{item.label}</option>
                        )}
                      </Select>  
                    </FormControl>

                  </GridItem>
                </GridContainer>  
              </div>
            </GridItem>
          </GridContainer>
          
          <GridItem xs={12} sm={11} md={11} style={{borderBottom: '1px solid #eee'}}>
            <div
              onClick={() => this.setState({...this.state, showTable: !this.state.showTable})}
              style={{
                display:'flex',
                alignItems: 'center',
                paddingTop: '30px',
                cursor:'pointer',
                maxWidth: '265px'
              }}
            >
              <div style={{paddingRight: '10px'}}>
                <ArrowDropDown />
              </div>
              <div style={{paddingRight: '10px'}}>
                <span>Custom Settings (Optional)</span>
              </div>
              <div style={{paddingRight: '3px'}}>
                <Checkbox
                  tabIndex={-1}
                  disabled={true}
                  checked={this.state.profileSpecialCases.length !== 0}
                  checkedIcon={
                    <Check className={classes.checkedIcon} />
                  }
                  icon={<Check className={classes.uncheckedIcon} />}
                  classes={{
                    checked: classes.checked
                  }}
                />
              </div>
            </div>
          </GridItem>

          {this.state.showTable && 
          <GridItem xs={12} sm={11} md={11} style={{marginTop: '30px'}}>
            <div style={{float: 'right'}}>
              <span
                onClick={() => this.addNewSpecialCase()}
              >
                <AddCircle
                  style={{
                    color: '#00acc1',
                    cursor: 'pointer'
                  }}
                />
              </span>
            </div>
            
          </GridItem>
          }
          {this.state.showTable && 
          <GridItem xs={12} sm={11} md={11} className={classes.paddingZero}>
          
            <div style={{border:'1px solid #AAAAAA', marginTop: '20px'}}>
              <Table
                tableHeaderColor="primary"
                //striped
                responsiveY
                firstChildFullWidth
                tableHead={{
                  symbols: 'Symbol Set',
                  spread: {name: 'Spread Rebate', width: '60px'},
                  markup:"Markup", 
                  //percentage:"Rebate on Shares",
                  commission: {name: 'Commission Rebate', width: '98px'},
                  commissionCurrencyId:"",
                  commissionType:"",
                  actions: ''
                }}
                tableData={specialCases.map((e,i) => {
                  //let currency = currencies.find((x) => x.currencyId === e.commissionCurrencyId).name
                  return [
                    //e.symbols,
                    this.renderTableSymbols(e),
                    this.renderTableInput(e, 'spread', 'Pips'),
                    this.renderTableInput(e, 'markup', 'Pips'),
                    //this.renderTableInput(e, 'percentage', '%'),
                    this.renderTableInput(e, 'commission', 'Input', '100px'),
                    this.renderTableSelect(e, 'commissionCurrencyId', 'Currency', currencies.map((c)=>{return{value: c.currencyId, label: c.name}})),
                    this.renderTableSelect(e, 'commissionType', 'Per lot/million', Object.values(mrPerType)),
                    <div>
                      
                      <span
                        style={{
                          cursor: 'pointer',
                          color: '#4caf50',
                          paddingRight: '5px'
                        }}
                        onClick={() => this.saveTableItem(e)}
                      >
                        <Check />
                      </span>

                      <span
                        style={{
                          color: '#f44336',
                          cursor: 'pointer',
                        }}
                        onClick={(x) => this.deleteTableItem(e)}
                      >
                        <Close />
                      </span>
                      
                      
                    </div>
                  ]}
                )}
              />
            </div>
          </GridItem>
          }
          
					<GridItem sm={11}>
						<div style={{float: 'right'}}>
              <button type='submit' ref={this.button} style={{visibility: 'hidden'}}></button>
							<Button
								color="success"
								type="button"
                style={{position:'absolute', bottom:'10px', right:'40px'}}
                onClick={()=> {
                  this.setState({...this.state, goToNext: true})
                  this.button.current.click()
                }}
							>
								Next
							</Button>
						</div>
					</GridItem>
          
          {this.state.openModal &&
            <SymbolsModal
              close={() => this.setState({openModal: false})}
              groups={this.state.symbolTree}
              selected={this.state.selectedSpecialCase}
              symbolGroups={this.props.symbolGroups}
              save={(id, data) => this.setSymbols(id, data)}
            />
          }

        </GridContainer>
      </form>
  	);
  }
}
const state=(state)=>({
  profileSpecialCases: state.profileSpecialCases.list,
  currencies: state.currencies.list,
  symbolGroups: state.symbolGroups.list
})
const dispatch=(dispatch)=>({
  fetchSpecialCase:(profileSpecialCaseId)=>dispatch(profileSpecialCaseFetch(profileSpecialCaseId)),
  fetchSpecialCases:(profileId)=>dispatch(profileSpecialCasesFetchHelper(profileId)),
  fetchProfile:(id)=>dispatch(profileFetch(id)),
  saveProfile:(data)=>dispatch(profileSave(data)),
  saveSpecialCase:(profileId, data)=>dispatch(profileSpecialCaseSave(profileId, data)),
  removeSpecialCase: (profileId, id) => dispatch(profileSpecialCaseRemove(profileId, id)),
  danger:(text,sec)=>dispatch(danger(text,sec)),
  success:(text,sec)=>dispatch(success(text,sec)),
  currenciesFetch: () => dispatch(currenciesFetch()),
  currencyFilter: (filter) => dispatch(currencyFilter(filter)),
  fetchAllSymbols: () => dispatch(fetchAllSymbols()),
  symbolGroupsFetch: () => dispatch(symbolGroupsFetch()),
  symbolGroupFilter: (filter) => dispatch(symbolGroupFilter(filter))
})
export default withStyles({...styles, ...regularFormsStyle, ...customStyle})(connect(state,dispatch)(Commodities))



// WEBPACK FOOTER //
// ./src/views/Profiles/Wizard/Commodities.jsx